import * as jsxRuntime from "/codebuild/output/src4292970808/src/web_eyeson/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment